import React from 'react';

const sizes = {
  tiny: 16,
  small: 20,
  medium: 24,
  large: 32,
};

export default function GiftCardIcon({ size = 'medium', className }) {
  const px = sizes[size] ?? sizes.medium;
  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="2"
        y="7"
        width="20"
        height="14"
        rx="2"
        stroke="var(--color-icon-lineart, currentColor)"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M2 11h20"
        stroke="var(--color-icon-lineart, currentColor)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 7V21"
        stroke="var(--color-icon-lineart, currentColor)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9 7c0-1.657 1.343-3 3-3s3 1.343 3 3"
        stroke="var(--color-icon-lineart, currentColor)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12 4c0 0-1-2.5 1-3 1.5-.36 2 1 1 3"
        stroke="var(--color-icon-lineart, currentColor)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
